export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";